export const API_URL = import.meta.env.VITE_API_URL 
    ? (import.meta.env.VITE_API_URL.endsWith('/') ? import.meta.env.VITE_API_URL : `${import.meta.env.VITE_API_URL}/`) 
    : 'https://api.eskrag.com/api/'
export const API_TIMEOUT = 100000
